import { render } from "./payment-request-summary.vue?vue&type=template&id=1afe1fe5&scoped=true"
import script from "./payment-request-summary.vue?vue&type=script&lang=js"
export * from "./payment-request-summary.vue?vue&type=script&lang=js"

import "./payment-request-summary.vue?vue&type=style&index=0&id=1afe1fe5&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afe1fe5"]])

export default __exports__